// src/main.tsx
// Purpose: App bootstrap. Wraps the app with AuthProvider so auth state is available everywhere.

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "@/auth/AuthProvider";
import App from "./App";
import "./index.css";
import { supabase, SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY } from './lib/supabaseClient';
import { installServiceErrorCapture } from './lib/serviceErrorCapture';

installServiceErrorCapture(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, async () =>
  (await supabase.auth.getSession()).data.session?.access_token ?? null);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>
);
